export default function ($scope, $location, $window, $anchorScroll, AuthenticationService, FlashService, Restangular, CifService, $mdDialog, $filter, promo) {
    if(GetData().currentUser)
        $location.path('/account');

    if(!promo){
        $location.path('/login');
        FlashService.Error('PROMO_UNAVAIABLE');
    }

    $scope.menu = function() {
        $('html').toggleClass("nav-open");
    };
    $scope.year = new Date().getFullYear();

    let date = new Date();
    date.setFullYear(date.getFullYear()-18);
    $scope.maxdate = date;

    $scope.roles_list = {
        'patient' : 'ROLE_PATIENT',
        'prescriber' : 'ROLE_PRENSCRIPTOR',
        'company' : 'ROLE_COMPANY'
    };

    Restangular
        .allUrl('states', AuthenticationService.Api.Public+'states')
        .getList({_filters: '{"country":"' + 1 + '"}', _sortDir: "ASC", _sortField: "name"})
        .then(data => {
            data = data.data ? data.data : data;

            $scope.states = data;
            $scope.apply();
        });

    Restangular
        .allUrl('prescriberTypes', AuthenticationService.Api.Public+'prescriberTypes')
        .getList({_sortDir: "ASC", _sortField: "description"})
        .then(data => {
            data = data.data ? data.data : data;

            $scope.prescriberTypes = data;
            $scope.updatePrescriptorType($scope.$root.current_language);

            $scope.apply();
        });


    $scope.$watch('username', function(){
        $scope.form.username.$setValidity('exists', true);
    });

    $scope.$watch('cif', function(value){
        $scope.form.cif.$setValidity('exists', true);

        if (!CifService.Validate(value)) {
            $scope.form.cif.$setValidity('invalid', false);
        }else{
            $scope.form.cif.$setValidity('invalid', true);
        }
    });

    $scope.$root.$watch('current_language', function(new_value){
        $scope.updatePrescriptorType(new_value);
    });

    $scope.updatePrescriptorType =  function(language){
        if(!$scope.prescriberTypes || !language) return false;

        $scope.prescriberTypes.map(function(type){
            if(type['description_'+language])
                type.label = type['description_'+language];
            else
                type.label = type['description'];

            return type;
        })
    };

    $scope.translate = function(text){
        return $filter('translate')(text);
    }

    $scope.problem = function(ev){
        var alert = $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .htmlContent ('<h3>'+$scope.translate('PROMO_PROBLEM_TITLE')+'</h3>' + "<br>" + $scope.translate('PROMO_PROBLEM_TEXT'))
                .targetEvent(ev)
                .fullscreen(true)
                .ok("ok")
            ;

        $mdDialog.show(alert)
            .finally(function() {
                $location.path('/login');
            });
    };

    $scope.register = function () {
        $scope.dataLoading = true;

        AuthenticationService.PublicLogin(function(response){
            if(response.status == "200") {

                let birthday = null;

                if($scope.birthday){
                    let date = new Date($scope.birthday);
                    birthday = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
                }

                let userData = {
                    username : $scope.username,
                    email : promo.email ? promo.email : $scope.email,
                    name : $scope.name ? $scope.name : $scope.company,
                    surname : $scope.surname,
                    roles : 'ROLE_PRENSCRIPTOR',
                    birthday: birthday,
                    prescriberType: $scope.precriberType,
                    city: $scope.city,
                    address: $scope.address,
                    postalCode: $scope.postalCode,
                    state: $scope.state,
                    phone: $scope.phone,
                    cif: $scope.cif,
                    promo: promo.token
                };

                if(!birthday)
                    delete userData.birthday;

                Restangular
                    .all('user')
                    .post(userData)
                    .then(data => {

                        FlashService.Success("CREATED_CHECK_YOUR_EMAIL");

                        $scope.dataLoading = false;

                        $location.path('/login');

                    }, error => {
                        $scope.dataLoading = false;

                        $anchorScroll("navbar");

                        let flash_error = "MALFORMET_DATA";
                        let modal = false;

                        error.data.fields.forEach(function(field, index){
                            if(field.property_path == 'email' || field.property_path == 'username'){
                                $scope.form[field.property_path].$setValidity('exists', false);
                            }

                            if(field.property_path == 'plainPassword'){
                                $scope.form[field.property_path].$setValidity('low', false);
                            }

                            if(field.property_path == 'ip' || field.property_path == 'cif'){
                                modal = true;
                            }
                        });

                        form.$invalid = false;

                        if(modal){
                            $scope.problem();
                        }else{
                            FlashService.Error(flash_error);
                        }

                    });
            }else{
                FlashService.Error("Internal Error")
            }
        }, true);

    };
};


/** WEBPACK FOOTER **
 ** ./js/theme/promo/controller.js
 **/